


















































import Vue from "vue";

export default Vue.extend({
  name: "DummyCard",
  props: {
    news: {}
  },
  data: () => ({}),
  methods: {
    openDialog() {
      this.$emit("open-dialog");
    }
  }
});
